<template>
    <div>
        <radio-checkbox-field
            :field="{label: $t('previousSurgery.hasPreviousSurgery')}"
            field-name="has-transfusions"
            v-model="hasPreviousSurgery"
        />

        <div v-if="hasPreviousSurgery">
            <p class="mx-3 mb-3 form-label">{{ $t('previousSurgery.hasPreviousSurgeryHelp') }}</p>
            <div
                v-for="(v, index) in $v.previousSurgeries.$each.$iter"
                :key="index"
                class="mx-3 mb-3 py-3 px-4 rounded border border-primary"
            >
                <multiple-card-item
                    :title="$t('previousSurgery.data')"
                    @delete="remove(parseInt(index))"
                >
                    <select-as-radio-field
                        v-model="v.type.$model"
                        :field="previousSurgeryFields.type"
                        :prefix-field-name="'previous-surgery-' + index + '-'"
                        :errors="v.type.$error ? {['type']: $t('error.required')}: {}"
                        :inline="false"
                        field-name="type"
                        class="mb-3"
                    />

                    <input-field
                        v-model="v.number.$model"
                        :field="previousSurgeryFields.number"
                        :prefix-field-name="'previous-surgery-' + index + '-'"
                        :errors="v.number.$error ? {['number']: $t('error.required')}: {}"
                        field-name="number"
                        type="number"
                    />

                    <select-as-radio-field
                        v-model="v.treatment.$model"
                        :field="previousSurgeryFields.treatment"
                        :prefix-field-name="'previous-surgery-' + index + '-'"
                        :errors="errors"
                        :inline="false"
                        field-name="treatment"
                        several
                    />

                    <input-field
                        v-model="v.note.$model"
                        :field="previousSurgeryFields.note"
                        :prefix-field-name="'previous-surgery-' + index + '-'"
                        :errors="errors"
                        :placeholder="$t('textarea.placeholder')"
                        :inline="false"
                        field-name="note"
                        form-width="auto"
                        no-center-text
                    />
                </multiple-card-item>
            </div>

            <div class="text-center">
                <hemocir-button
                    :title="$t('previousSurgery.addOtherPreviousSurgery')"
                    font-awesome-icon="fa-plus-circle"
                    variant="outline-gray"
                    class="add-previous-surgery"
                    @click="add"
                />
            </div>
        </div>

    </div>
</template>

<script>
    import RadioCheckboxField from "@/components/fields/RadioCheckboxField";
    import {mapState} from "vuex";
    import InputField from "@/components/fields/InputField";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import {cloneDeep} from "lodash";
    import {required} from "vuelidate/lib/validators";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";
    import ScrollToErrorMixin from "@/components/mixins/ScrollToErrorMixin";
    import MultipleCardItem from "@/components/MultipleCardItem";

    export default {
        name: "PatientPreviousSurgery",
        components: {MultipleCardItem, SelectAsRadioField, InputField, RadioCheckboxField},
        mixins: [ScrollToErrorMixin],
        data() {
            return {
                hasPreviousSurgery: null,
                previousSurgeries: [],
            };
        },
        computed: {
            ...mapState(['previousSurgeryFields', 'patient']),
            ...mapStateProperty([
                {path:'patient.previous_surgeries', name: 'patientPreviousSurgeries'}
            ]),
            errors() {
                return {};
            }
        },
        watch: {
            hasPreviousSurgery(newValue) {
                if (newValue && this.previousSurgeries.length === 0) {
                    this.add();
                }
                if (!newValue) {
                    this.previousSurgeries = [];
                }
            }
        },
        created() {
            if (this.patient.hasOwnProperty('previous_surgeries')) {
                this.hasPreviousSurgery = this.patient.previous_surgeries.length > 0;
                this.previousSurgeries = cloneDeep(this.patient.previous_surgeries);
            }
        },
        methods: {
            validate() {
                this.$v.$touch();
                const isValid = !this.$v.$invalid;
                if (isValid) {
                    this.storePreviousSurgeriesInPatient();
                } else {
                    this.$nextTick(this.scrollToError);
                }
                return isValid;
            },
            back() {
                this.storePreviousSurgeriesInPatient();
                return true;
            },
            storePreviousSurgeriesInPatient() {
                this.patientPreviousSurgeries = cloneDeep(this.previousSurgeries);
            },
            add() {
                this.previousSurgeries = this.previousSurgeries.concat([{
                    type: '',
                    number: null,
                    treatment: [],
                    note: '',
                }]);
            },
            remove(index) {
                this.previousSurgeries.splice(index, 1);
            }
        },
        validations: {
            previousSurgeries: {
                $each: {
                    type: {
                        required
                    },
                    number: {
                        required
                    },
                    treatment: {},
                    note: {},
                }
            }
        }
    };
</script>

<style scoped>
</style>